// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2lCOi","topBottomGutter":"Layout_topBottomGutter__2tIm_"};